import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

export const TabPanel = (props: TabPanelProps) => {
  const { id, active, className, children } = props;

  return (
    <ul
      key={id}
      data-id={id}
      data-active={active}
      role="tabpanel"
      className={clsx(className, {
        active,
      })}
    >
      {children}
    </ul>
  );
};

export interface TabPanelProps extends PropsWithChildren {
  id: string;
  active?: boolean;
  className?: string;
}
